import React from 'react';
import ChatInputBanner, { ChatInputBannerAction } from './ChatInputBanner';
import { useChatInputStore } from '@/store';
import { hasComposerDraftContent } from '@/lib/composerSendDraft';
import useTranslation from '@/hooks/useTranslation';

function ChatInputSavedSendDraftBanner({ contextId, ...props }) {
  const { t } = useTranslation();
  const hasDraft = useChatInputStore(s => hasComposerDraftContent(s.inputStates[contextId]));
  const restore = useChatInputStore(s => s.restoreSendDraft);
  return <ChatInputBanner {...props} color="warning"
    actions={<ChatInputBannerAction onPress={() => restore(contextId)}>
      {t(hasDraft ? 'chatInput.switchSavedDraft' : 'chatInput.restoreSavedDraft')}
    </ChatInputBannerAction>}>
    {t('chatInput.unsentDraftSaved')}
  </ChatInputBanner>;
}

export default React.memo(ChatInputSavedSendDraftBanner);
